import { PermissionsScope } from '../../policies'

export const MANUFACTURER_FRAGMENT = 'manufacturer'
export const MANUFACTURER_SCOPE: PermissionsScope = 'manufacturers'
